import { IconCar, IconMotorbike } from "@tabler/icons-react";

export const VEHICLE_CONFIG = {
  car: {
    icon: IconCar,
    color: "indigo",
  },
  motorbike: {
    icon: IconMotorbike,
    color: "teal",
  },
};
